import * as echarts from 'echarts';
import { showTimeByDateType, valueFormat } from '@/pages/intelligence/utils/commonUtils';

import ChartBubble from '@/pages/intelligence/components/ChartBubble';

export const getPriceEcharts = (
  recordsList: any[],
  dateType: string,
  metricTitle = 'est_price_time',
) => {
  setTimeout(() => {
    recordsList?.forEach((e: any, index) => {
      const appId = e?.app_id || e?.id
      const metrics = e.metric_list || [];
      const metric = metrics?.find(
        (item: any) => item.title === metricTitle || item.metric === metricTitle,
      );
      const dataList =
        metric?.history?.length > 30
          ? metric?.history?.slice(-30)
          : metric?.history || [];
      const valueList = dataList?.map((item: any) => item?.value);
      const dateList = dataList?.map((item: any) => showTimeByDateType(item.time, dateType));
      if (document.getElementById(`echarts${appId}`)) {
        echarts
          .init(
            document.getElementById(`echarts${appId}`) as HTMLElement,
            'macarons',
          )
          .dispose();
        const myChart = echarts.init(
          document.getElementById(`echarts${appId}`) as HTMLElement,
          'macarons',
        ); // 修改折线图分辨率

        const options = {
          grid: {
            top: '10px',
            // left: '-5%',
            left: -30,
            right: '0',
            bottom: '-40%',
            containLabel: true,
          },
          tooltip: {
            show: true,
            trigger: 'axis',
            backgroundColor: 'rgba(255,255,255,0.8)',
            // position: {  top: 32 },
            // position: { left: -125, top: -12 },
            // position: function (point, params, dom, rect, size) {
            //   //表格第一个，固定显示在下方
            //   return index == 0 ? [point[0] - 150, point[1] + 20] : null;
            // }
            appendToBody: true, // 浮窗节点挂载在body下，不被表格遮挡
            padding: 0,
            borderWidth: 0,
            // appendToBody: true,
            axisPointer: {
              type: 'none',
            },
            formatter: (params: any) => {
              if (!Array.isArray(params)) {
                return params;
              }
              const data = params?.map((item) => {
                const price = valueFormat(item?.value, false, 0);
                return {
                  ...(item || {}),
                  seriesName: 'Price($)',
                  value: price == 0 ? 'Free' : price,
                };
              });
              return ChartBubble({
                data,
                // titleNow: titleNow,
                chartType: 'line',
                dateType,
                ifNoBarImg: true,
                isPercent: false,
                topChartsType: 'metrictable-steam-price',
              });
              // return formatterTooltip(params, dateType);
            },
          },
          xAxis: {
            type: 'category',
            data: dateList,
            // 不显示x轴线
            show: false,
            axisLabel: {
              interval: 0,
            },
            // max: function (value: any) {
            //   return value.max + value.max * 0.1;
            // },
            // min: function (value: any) {
            //   return value.min - value.min * 0.1;
            // }
          },
          yAxis: {
            type: 'value',
            show: false,
          },
          series: [
            {
              showSymbol: false,
              symbol: (value, params) => {
                if (valueList?.length <= 14) {
                  return 'emptyCircle';
                }
                const index = params?.dataIndex;
                return index % 2 === 0 ? 'none' : 'emptyCircle';
              },
              symbolSize: 3,
              type: 'line',
              step: dateType == 'daily',
              data: valueList,
              itemStyle: {
                color: '#4863D6',
              },
            },
          ],
        };

        myChart.setOption(options);

        window.addEventListener('resize', () => {
          myChart.resize();
        });
      }
    });
  }, 1000);
};

// const formatterTooltip = (params: any, dateType: string) => {
//   const newParams = Array.isArray(params) ? params[0] : {};
//   const price = valueFormat(newParams?.value, false, 0);
//   let returnStr = `
//           <div style="font-size:12px;background-color: #fff;width: 120px;">
//               <div style="color:#000000;opacity:0.65;text-align: left;float:left;margin-right:20px;display:inline-block;">
//                   ${
//                     newParams?.axisValue
//                       ? showTimeByDateType(newParams?.axisValue, dateType)
//                       : ''
//                   }
//               </div>
//               <br>
//               <div style="color:#000000;opacity:0.85;float:left;display:inline-block;">
//                 ${'Price($)'}
//               </div>
//               <div style="color:#000000;opacity:0.85;float:right;display:inline-block;font-weight: 600;">
//                   ${price == 0 ? 'Free' : price}
//               </div>
//           </div>`;
//   return returnStr;
// };

export default {};
